module.exports = __webpack_public_path__ + "static/media/chevron.a7254bd2.svg";